import { createFrontendModule } from '@backstage/frontend-plugin-api';
import { EntityCardBlueprint } from '@backstage/plugin-catalog-react/alpha';
import { keycloakAppClient } from '@internal/backstage-plugin-app-credentials-common';

/**
 * "Credentials" card on keycloak-config app entities (those with the
 * `pubinvest.co.uk/keycloak-client-id` annotation), attached to the catalog's
 * entity overview. API: plugins/app-credentials-backend.
 */
const credentialsCard = EntityCardBlueprint.make({
  name: 'app-credentials',
  params: {
    filter: entity => Boolean(keycloakAppClient(entity)),
    loader: () =>
      import('./CredentialsCard').then(({ CredentialsCard }) => (
        <CredentialsCard />
      )),
  },
});

export const appCredentialsModule = createFrontendModule({
  pluginId: 'catalog',
  extensions: [credentialsCard],
});
